<script>
import axios from "axios";
import { getTokenHeader } from "@/helpers/commonHelper";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "DuplicatesActions",
  props: {
    item: {
      type: Object,
      required: true
    },
    apiKeys: {
      type: Array,
      required: false
    }
  },
  data() {
    return {
      dialog: false,
      selectedApiKeys: [],
      loading: false
    };
  },
  computed: {
    checkDuplicate() {
      return (
        this.item?.duplicate?.principal || this.item?.duplicate?.apiKeys?.length
      );
    }
  },
  created() {
    this.selectedApiKeys = this.item?.duplicate?.apiKeys || [];
  },
  methods: {
    editEvent(item) {
      this.$emit("editEvent", item);
    },
    previewEvent(item) {
      this.$emit("previewEvent", item);
    },
    open(item) {
      window.open(`/events/events/${item._id}`, "_blank");
    },
    markEventAsDuplicate(options = { all: false }, item) {
      const { all, type } = options;
      this.loading = true;
      const hiddenFor = all ? this.apiKeys : this.selectedApiKeys;
      const headers = getTokenHeader();
      const updateData = {
        id: item._id,
        type,
        duplicateOf: item.duplicateOf
      };

      if (type === "apiKey") {
        updateData.apiKeys = hiddenFor;
      } else if (type === "principal") {
        if (item.duplicate.principal) {
          updateData.unsetDuplicate = true;
        } else {
          updateData.principal = item.principal_id;
        }
      }

      axios
        .post(`${env.events_api_client_url}event/setDuplicate`, updateData, {
          headers
        })
        .then(() => {
          // update list
          this.$emit(
            "updateList",
            hiddenFor,
            updateData.unsetDuplicate
              ? ""
              : type === "principal"
              ? item.principal_id
              : ""
          );
        })
        .finally(() => {
          this.dialog = false;
          this.loading = false;
        });
    }
  }
};
</script>

<template>
  <div>
    <v-btn class="mr-2" color="primary" @click="previewEvent(item)"
      >Vorschau</v-btn
    >
    <v-btn class="mr-2" color="primary" @click="open(item)">Öffnen</v-btn>

    <v-btn color="primary" dark @click.stop="dialog = true">
      Ausblenden
    </v-btn>

    <v-dialog v-model="dialog" max-width="600">
      <v-card>
        <v-card-title class="text-h5 wrap">
          Veranstaltung für folgende Api-Keys ausblenden
        </v-card-title>

        <v-card-text>
          <div v-if="apiKeys">
            <v-checkbox
              :disabled="loading"
              v-model="selectedApiKeys"
              v-for="ak in apiKeys"
              :label="ak.description"
              :value="ak.apiKey"
              :key="ak.apiKey"
            ></v-checkbox>
          </div>
          <div v-else>
            Wirklich "{{ item.title }}"
            {{ checkDuplicate ? "einblenden" : "ausblenden" }}?
          </div>
          <v-progress-circular
            v-if="loading"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-card-text>

        <v-card-actions v-if="!loading">
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="dialog = false">
            Abbrechen
          </v-btn>
          <template v-if="apiKeys">
            <v-btn
              color="green darken-1"
              text
              @click="
                markEventAsDuplicate({ all: false, type: 'apiKey' }, item)
              "
            >
              <v-icon>mdi-check</v-icon> Ausgewählte ausblenden
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              @click="markEventAsDuplicate({ all: true, type: 'apiKey' }, item)"
            >
              <v-icon>mdi-check-all</v-icon> Alle ausblenden
            </v-btn>
          </template>
          <template v-else>
            <v-btn
              color="green darken-1"
              text
              @click="markEventAsDuplicate({ type: 'principal' }, item)"
            >
              <v-icon>mdi-check</v-icon>
              {{ checkDuplicate ? "Einblenden" : "Ausblenden" }}
            </v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped></style>
